import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import React, { useEffect, useState } from "react";
import { useFirstAuthCompleted } from "@/features/user/hooks/use-first-auth-completed";
import { useLoginContext } from "@/features/auth/contexts/login-context";
import { useLocation, useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { FirstAuthCompletedService } from "../services/first-auth-completed-service";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";
import { useErrorContext } from "@/shared/context/error-context";
import { MoneyLinkWarning } from "@/shared/utils/custom-exception";

export const FirstAuthCompleted = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token") ?? "";
  const firstAuthCompletedService = new FirstAuthCompletedService();
  const {
    setEmail,
  } = useLoginContext();
  const {
    activateUser,
  } = useFirstAuthCompleted();
  const { setError } = useErrorContext();
  const [ownerId, setOwnerId] = useState<string>("");
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    const load = async () => {
      try {
        await firstAuthCompletedService.firstAuthCompletedInit({token: token});
        const res = await activateUser(token);
        if (res) setOwnerId(res);
      } catch (error: any) {
        // ネットワークエラー等
        setError(new MoneyLinkWarning({
          title: "確認",
          message: error.message
        }));
        navigate(EndpointPathNames.LOGIN);
        return;
      }
    };
    load();
  }, []);

  useEffect(() => {
    if (ownerId === "") return;
    setShow(true);
  }, [ownerId]);


  // メールアドレスフォームに付与するID
  const mailAddressFormId = "mail_address_form_id";

  if (!show) {
    return null;
  }
  return (
    <>
      <LoginHeader content="メールアドレス認証" />
      <main>
        <section id="rePass" className="auth-completed">
          <nav className="step">
            <ol>
              <li className="done">認証メールを送信</li>
              <li className="active">認証完了</li>
            </ol>
           </nav>
          <p>メールアドレスの認証が完了しました。</p>
          <ul className="form">
            <li>
              <MailAddressForm
                id={mailAddressFormId}
                initialValue={ownerId}
                isReadOnly={true}
                title="メールアドレス"
              />
            </li>
          </ul>
          <div className="notice">
            <p>引き続き、認証が完了したメールアドレスでログインしてください。<br/>
              パスワードは現在のものを引き続きご利用ください。
            </p>
            <p>連携製品で取引明細を取り込む場合は、連携製品に戻ることで、引き続き取引明細の取り込みが行えます。</p>
          </div>
          <nav className="btns">
            <BaseRoundButton
              buttonText="ログインへ"
              onClick={() => {
                setEmail(ownerId);
                navigate(EndpointPathNames.LOGIN)
              }}
              className="nav-main"
              isActive={true}
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
